/* @flow */
const Products = Object.freeze({
    MOTION_TRACK: 'MOTIONTRACK',
    DISPATCHER: 'DISPATCHER',
    DISPATCHER_PLANNER: 'DISPATCHER_PLANNER',
    FIELD_PRO: 'FIELDPRO',
    PLATFORM: 'PLATFORM',
    INTELLISORT: 'INTELLISORT',
    ROUTING: 'ROUTING',
    NETWORK_OPTIMIZATION: 'NETWORK_OPTIMIZATION',
    ORCHESTRATOR: 'ORCHESTRATOR',
    CONTRACTS: 'CONTRACTS',
    ROSTER: 'ROSTER',
    ORCHESTRATION: 'ORCHESTRATION'
});

export type ProductType = $Values<typeof Products>;

export const BEProducts = Object.freeze({
    DISPATCHER: 'DISPATCHER',
    FIELDPRO: 'FIELDPRO',
    INTELLISORT: 'INTELLISORT',
    MOTIONTRACK: 'MOTIONTRACK',
    NETOPT: 'NETOPT',
    ORCHESTRATIONIQ: 'ORCHESTRATIONIQ',
    ORDERIQ: 'ORDERIQ',
    PLATFORM: 'PLATFORM',
    ROUTING: 'ROUTING'
});
export type BEProductType = $Values<typeof BEProducts>;

export default Products;
